import { useFacilityById } from "@/common/AppConfigUtils";
import { useAppSelector, useCurrentFacility, useCurrentUnit } from "@/common/hooks";
import { useIsHealthSystemBasedView } from "@/common/hooks/useIsHealthSystemBasedView";

/**
 * Custom hook that determines the selected health system ID based on the current view context.
 *
 * This hook evaluates whether the current view is health system-based and returns the appropriate
 * health system ID. If the view is health system-based, it returns the current health system ID
 * from the application state. Otherwise, it attempts to retrieve the health system ID from the
 * current facility or the facility associated with the current unit.
 *
 * @returns {string | undefined} The selected health system ID or undefined if not applicable.
 */
export const useDropdownSelectedHealthSystemId = () => {
  const currentHealthSystemId = useAppSelector((state) => state.common.currentHealthSystemId);
  const currentFacility = useCurrentFacility();
  const currentUnit = useCurrentUnit();
  const currentViewUsesHealthSystemSelector = useIsHealthSystemBasedView();
  const facility = useFacilityById(currentUnit?.facilityId);

  return currentViewUsesHealthSystemSelector
    ? currentHealthSystemId || undefined
    : currentFacility?.healthSystemId || facility?.healthSystemId || undefined;
};
